import { useProjectLearningOutcomes } from '@openclassrooms/data-connect-web/learning-content';

import LearningOutcomeListItem from '../LearningOutcomeListItem';

export function ProjectLearningOutcomeListItems({ className = '', projectId }) {
  const { data: learningOutcomes = [] } = useProjectLearningOutcomes({ projectId });

  return (
    <ul className={className}>
      {learningOutcomes.map(({ id, name }) => (
        <LearningOutcomeListItem component="div" key={id} title={name} />
      ))}
    </ul>
  );
}

export default ProjectLearningOutcomeListItems;
